import setUtil from 'utils/set'
import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

function saveError (state, action) {
  const {
    error,
    path
  } = action.payload
  const obj = getObjectUtil(state, path)
  if (!obj) {
    return state
  }
  return setUtil(state, path, {
    ...obj,
    status: REDUX_STATUS.ERROR,
    error,
    validation: null,
    updatedAt: (new Date()).toISOString()
  })
}

export default saveError
